export default __webpack_public_path__ + "static/media/header-caret-up.daf84566.svg";